import { jsx as _jsx } from "react/jsx-runtime";
import { LogoImage, LogoWrapper } from "./style";
import nameLogoBlue from "../../assests/name_logo_blue.jpg";
const CompanyLogo = () => {
    return (_jsx(LogoWrapper, { children: _jsx(LogoImage, { src: nameLogoBlue, alt: "Company Logo", crossOrigin: "anonymous" }) }));
};
export default CompanyLogo;
